export const V1_SUBMIT_SEARCH_QUERY = 'V1_SUBMIT_SEARCH_QUERY'

export default data => {
  return {
    type: V1_SUBMIT_SEARCH_QUERY,
    data,
  }
}
